import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../brand';

// ============================================================================
//  StepHeading — the title block at the top of every setup step.
// ============================================================================
//  Factored out so all four steps share identical spacing and icon treatment.
//  The subtitle is where each step explains *why* it is asking, which matters
//  in a wizard the operator runs exactly once and cannot easily redo.

function StepHeading({ icon: Icon, title, subtitle }) {
  return (
    <Box sx={{ mb: { xs: 2.25, md: 3 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.25, md: 1.75 }, mb: 1 }}>
        {Icon && (
          <Box
            sx={{
              width: { xs: 34, md: 40 }, height: { xs: 34, md: 40 },
              borderRadius: '11px', flexShrink: 0,
              background: BRAND.navySoft,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <Icon sx={{ fontSize: { xs: 18, md: 21 }, color: BRAND.navy }} />
          </Box>
        )}
        <Typography
          sx={{
            fontSize: { xs: 18, md: 21 }, fontWeight: 800,
            color: BRAND.ink, letterSpacing: '-.3px',
          }}
        >
          {title}
        </Typography>
      </Box>
      {subtitle && (
        <Typography
          sx={{
            fontSize: { xs: 12.5, md: 13.5 }, color: BRAND.inkMuted,
            lineHeight: 1.65, maxWidth: 640,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export default StepHeading;
